{
  "id": "campaign-160",
  "name": "The Great Meadow",
  "seed": "campaign:160",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".............T.........h",
    "....................m.m.",
    ".~.~....T............m..",
    "..........T.............",
    "........................",
    "...#...#........h...#...",
    "...............x........",
    ".......*...Y............",
    "x.......................",
    "...k...........*...Y....",
    "........................",
    "...,..h.................",
    "..,ww...................",
    "wwwww+w..........x..,.x.",
    "......ww................",
    "......mwwwww+wwww.....m.",
    ".....mmm........www+wwww",
    "#..x..m...T...........m.",
    "............#.k...T.....",
    "........................",
    "..............h.~.~.....",
    ".......Y.........~x.....",
    "......................T.",
    "........................",
    "..................h..T..",
    "S.......T.....#........."
  ],
  "critters": [
    {
      "kind": "deer",
      "x": 10,
      "y": 11
    },
    {
      "kind": "deer",
      "x": 10,
      "y": 10
    },
    {
      "kind": "stag",
      "x": 4,
      "y": 6
    },
    {
      "kind": "fox",
      "x": 12,
      "y": 22
    },
    {
      "kind": "deer",
      "x": 7,
      "y": 3
    },
    {
      "kind": "deer",
      "x": 7,
      "y": 2
    },
    {
      "kind": "deer",
      "x": 21,
      "y": 15
    },
    {
      "kind": "deer",
      "x": 21,
      "y": 14
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 17
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 21,
      "y": 9
    },
    {
      "kind": "gas",
      "x": 17,
      "y": 20
    },
    {
      "kind": "gas",
      "x": 19,
      "y": 16
    },
    {
      "kind": "gas",
      "x": 14,
      "y": 21
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 21
    },
    {
      "kind": "coin",
      "x": 18,
      "y": 20
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 20
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 24
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 23
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 21
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 19,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 24
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 20,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 18
    },
    {
      "kind": "coin",
      "x": 19,
      "y": 18
    },
    {
      "kind": "rare",
      "x": 22,
      "y": 0
    },
    {
      "kind": "repair",
      "x": 11,
      "y": 2
    }
  ],
  "hills": [
    {
      "x": 0,
      "y": 2,
      "w": 5,
      "h": 5
    },
    {
      "x": 14,
      "y": 17,
      "w": 5,
      "h": 5
    },
    {
      "x": 0,
      "y": 14,
      "w": 3,
      "h": 3
    }
  ],
  "generatorVersion": 3,
  "level": 160,
  "biome": "meadow",
  "par": {
    "reel": 22119,
    "push": 20246,
    "selfPropelled": 18237,
    "tractor": 15534,
    "zeroTurn": 12355,
    "fairway": 8629
  }
}
